import { render, staticRenderFns } from "./reductionReason.vue?vue&type=template&id=555fd4cf&"
import script from "./reductionReason.vue?vue&type=script&lang=js&"
export * from "./reductionReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports